import { BadgeEuro, PiggyBank, ClipboardList, ShieldCheck, MessageCircle, Scale } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import PublicLayout from "@/components/PublicLayout";
import PathHero from "@/components/PathHero";
import SalesGrid from "@/components/sections/SalesGrid";
import Steps from "@/components/sections/Steps";
import WhyFree from "@/components/WhyFree";
import FormSection from "@/components/sections/FormSection";
import FAQ from "@/components/FAQ";
import { Reveal } from "@/components/Reveal";

const OWNER_IMG =
  "https://images.unsplash.com/photo-1583295125721-766a0088cd3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxhbXN0ZXJkYW0lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzg3MjU4NzU4fDA&ixlib=rb-4.1.0&q=85";
const SALES_ICONS = [BadgeEuro, PiggyBank, ClipboardList, ShieldCheck, MessageCircle, Scale];

export default function OwnerPage() {
  const { t } = useLang();
  const o = t.owner;

  return (
    <PublicLayout variant="owner">
      <PathHero
        image={OWNER_IMG}
        badge={o.hero.badge}
        title={o.hero.title}
        subtitle={o.hero.subtitle}
        cta={o.hero.cta}
        note={o.hero.note}
        trust={t.chooser.trust[0]}
      />

      {/* Stat band */}
      <section className="bg-paper border-b border-line">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid grid-cols-3 divide-x divide-line">
          {o.stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.08} className="py-8 md:py-10 px-3 text-center">
              <div className="font-serif font-semibold text-3xl md:text-5xl text-brand tracking-tight leading-none">{s.big}</div>
              <div className="mt-2 text-xs md:text-sm text-stone">{s.small}</div>
            </Reveal>
          ))}
        </div>
      </section>

      <FormSection kind="owner" />
      <SalesGrid overline={o.sales.overline} title={o.sales.title} cards={o.sales.cards} icons={SALES_ICONS} />
      <WhyFree />
      <Steps overline={o.steps.overline} title={o.steps.title} items={o.steps.items} />
      <FAQ overline={o.faq.overline} title={o.faq.title} items={o.faq.items} />
    </PublicLayout>
  );
}
